

import cyoApiListService from '~/services/api/cyoListApi';
import  productListingHelpers from '~/utils/helper/cyoProductListHelper.js';
import { encodeURL } from '~/helper/index.js';
import { cyoStore }  from '../cyo/cyo';
import { cyodetailStore }  from '../cyodetail/cyodetail';

export default {

    routeInstance : null,
    routerInstance : null,

    setRouteInstance( routeInstance, routerInstance ) {
     
        this.routeInstance = routeInstance != null ? routeInstance : useRoute();

        this.routerInstance = routerInstance != null ? routerInstance : useRouter();

        // console.log('setRouteInstance',routeInstance, routerInstance, this.routeInstance, this.routerInstance )
    },
    

    // setup filters
    // call server for latest min max
    // once min max is received then change it accordinglyv to url params
    async resetCyoTemoraryState(data) {
        const storeDetail = cyodetailStore()
        await this.commitMutation( 'resetSettingFilterPage' )
        await storeDetail.commitMutation( 'resetSettingForDetailPage' )
    },


    async popStateUpdate( data, routeInstance, routerInstance ){

        
        this.setRouteInstance(routeInstance, routerInstance )
        
        // this.setupCyoSettingFilterFromUrl();

        // this.setRequestPayload( { unsetStartWith : false });
        
        // validate in case of create your own, exclude incase of loose 
        // if ( data.moduleType === 'cyo' && data.page === 'setting' ) {

        //     this.validateCyoSettingCase( data);
        // }
        
        // if ( data.moduleType === 'cyo' && data.page === 'diamond' ) {

        //     this.validateCyoDiamondCase( data);
        // }

        await  this.requestServer({ clearListing : true } )
    },



    async popStateUpdate( data, routeInstance, routerInstance ){

        
        this.setRouteInstance(routeInstance, routerInstance )
        
        this.setupCyoSettingFilterFromUrl();

        this.setRequestPayload( { unsetStartWith : false });
        
        // validate in case of create your own, exclude incase of loose 
        // if ( data.moduleType === 'cyo' && data.page === 'setting' ) {

        //     this.validateCyoSettingCase( data);
        // }
        
        // if ( data.moduleType === 'cyo' && data.page === 'diamond' ) {

        //     this.validateCyoDiamondCase( data);
        // }

        await  this.requestServer({ clearListing : true } )
    },

    // setup filters
    // call server for latest min max
    // once min max is received then change it accordinglyv to url params
    
    async setupCyoSettingFilter(data, routeInstance, routerInstance) {
      
        // try{
            // console.log('abcd');
            
            this.setRouteInstance(routeInstance, routerInstance )
        
            // this.nuxtOldMutations()
            this.commitMutation('setCyoSettingFilter', data);
            // if( import.meta.client ){

            //     this.commitMutation( 'setSettingListingResults', { clearListing: true, response: { data : [], total : 0, next_page_url: null } } )
            // }
            

            const callbackFn = async (res) => {


                // return
                await this.commitMutation('setCyoSettingFilterOptions', res);

                
                this.setupCyoSettingFilterFromUrl();
                
                
                this.setRequestPayload( { unsetStartWith : false });
                
                // validate in case of create your own, exclude incase of loose 
                if ( data.moduleType === 'cyo' && data.page === 'setting' ) {

                    this.validateCyoSettingCase( data);
                }
                
                if ( data.moduleType === 'cyo' && data.page === 'diamond' ) {

                    this.validateCyoDiamondCase( data);
                }

                await  this.requestServer({ clearListing : true } )
            }



            const minMaxPath = cyoApiListService(this).getMinMax( data )


            const useFetchPromise = await $fetch( minMaxPath,{
                method:'GET'
            } )


            await callbackFn( useFetchPromise.data  )

    },


    // once min max is received then change it accordinglyv to url params 
    async validateCyoSettingCase(data) {
        const cyo = cyoStore()

        this.setRouteInstance( )

        if (import.meta.server) {

            return
        }


        // disable shape filter if diamond is selected
        const diamond =  cyo.getDiamond( data.moduleSubType )
        const filter  = this.getSettingFilter( data.moduleSubType, 'shape' )
        const options = this.getSettingFilterOptions( data.moduleSubType, 'shape' )


        if(  diamond && options ){

            // set shape filter
            this.toggleSettingFilter( { reset:false, moduleSubType: data.moduleSubType , filter: filter , option : { value : diamond.shape }  })

            // since shape is selcetec, hide the shape dropdown
            // this.commitMutation( 'unsetSettingFilterShapeFilter', data )
            return
        }
        // end disable shape filter if diamond is selected


        // check if shape is presennt in cyo state
        // if shape is previously selected from setting select shape dropdown

        // const shape =  this.getShape( data.moduleSubType )

        // if ( shape ) {

        //     vuexContext.dispatch('toggleSettingFilter', { reset:false, moduleSubType: data.moduleSubType , filter: filter , option : { value : shape }  })
        //     return
        // }

    },

    // once min max is received then change it accordinglyv to url params 
    async validateCyoDiamondCase(data) {

        this.setRouteInstance( )

        const cyo = cyoStore()
        const cyoDetail = cyodetailStore()
        if (import.meta.server) {

            return
        }

        const setting   = cyo.getSetting( data.moduleSubType )
        
        const shape     =  cyoDetail.getSettingShape( data.moduleSubType )

        const options   =  this.getSettingFilterOptions( data.moduleSubType, 'shape' )
        if (!setting || !options ) {

            return
        }

        // unset shapes
        await  this.commitMutation('disableDiamondFilterShapes', { setting:setting, shape:shape }  )

        return  this.configureDiamondPayload( {setting})

    },

    // once min max is received then change it accordinglyv to url params 
    configureDiamondPayload({setting}) {

        // check if correct shapes payload set i.e. remove unavailable shapes
        const payload   = this.getRequestPayload()

        // THIS IS WHAT HAPPENS WHEN YOU DONT HAVE TIME, CANT WRITE PROPER CODE
        
        // if payload is not set or it is empty, we will call all shapes available in setting
        if ( ! payload.Shape || payload.Shape.length < 1 ) {
            
            payload.Shape = setting.avail_shapes.map( (cv) => cv.charAt(0).toUpperCase() + cv.slice(1)  )
            
            this.commitMutation( 'setRequestPayload', payload )
            
            return false
        }
        else if(payload.FieryRound && payload.FieryRound === 'Yes'){
            delete payload.Shape
            this.commitMutation( 'setRequestPayload', payload )
            return false
        }
        // if payload has shapes, we will check if it doesnt contain incompatible shapes with setting
        // if yes we will remove them
        else if ( payload.Shape.length ) {

            // verify shapes with setting avaiable shapes
            payload.Shape = payload.Shape.filter( (cv) => setting.avail_shapes.includes( cv.toLowerCase() )  )

            // is shapes become 0 we will enabled all setting shapes
            if ( payload.Shape.length < 1 ) {

                payload.Shape = setting.avail_shapes.map( (cv) => cv.charAt(0).toUpperCase() + cv.slice(1)  )
            }


            this.commitMutation( 'setRequestPayload', payload )
            return false
        }        

    },


    // once min max is received then change it accordinglyv to url params 
    setupCyoSettingFilterFromUrl(data) {

        // productListingHelpers.init( this )

        // productListingHelpers.setFiltersFromUrl()

        productListingHelpers.init( this )

        productListingHelpers.setFiltersFromUrl(  )
    },


    // improve this later
    async toggleSettingFilter(data) {
     
        const cyo = cyoStore()
        this.setRouteInstance( )

        //donot send request on view toggle (list/grid)
        if(data.name != 'listview'){
            this.commitMutation( 'setSettingShowSkeleton', { flag : true } )
            
            // clear listing
            this.commitMutation( 'setSettingListingResults', { clearListing: true, response: { data : [], total : 0, next_page_url: null } } )
        }
        
        
        //  check if setting list page and shape filter is changed
        // update shape if its change from settinng list dropdown onnly if the diamond is not selected
        if ( 
            import.meta.client && 
            this.getSettingListPageType() === 'setting' && 
            this.getModuleType() === 'cyo' && 
            data.filter.type === 'select' 
        ) {
               
            data.flagSetCyoShape = true

            const diamond =  cyo.getDiamond( this.getModuleSubType() )
           
            // if diamond is selected the do not change shape
            // filter is removed but still kept the case
            if (diamond) {

                data.flagSetCyoShape = false
            }
        }
        // end check


        // toggle dropdown filter
        // cyo shape is chnage inn toggleSettingFilter
        if (data.filter.type === 'select') {
          
            this.commitMutation( 'toggleSettingFilter', data )
            
        }

        // toggle checkbox filter
        if (data.filter.type === 'checkbox') {

            this.commitMutation( 'toggleSettingFilterCheckbox', data )
        }

        // toggle select group -> sort dropdown
        if (data.filter.type === 'select_group') {

            this.commitMutation( 'toggleSettingFilterSelectGroup', data )
        }

        // end filter toggle

        this.setRequestPayload({ unsetStartWith : true, updateURLHistory : true })
         //donot send request on view toggle (list/grid)
        if(data.name === 'listview'){
            return
        }
        return this.requestServer(  { clearListing : true } )
    },


    toggleSettingFilterVisibility(data) {

        this.commitMutation( 'toggleSettingFilterVisibility', data  )
    },


    setRequestPayload( data ){

        productListingHelpers.init( this )

        const {payload, filterTags} = productListingHelpers.setRequestPayload( data )

    
        // setting or diamond
        const moduleType = this.getModuleType()
        const pageType = this.getSettingListPageType()
        const moduleSubType = this.getModuleSubType()

        // set listing page url to preserve users filters
        if (import.meta.client && moduleType === 'cyo') {

            let listingUrl = {...payload}

            if ( listingUrl.page !== undefined) {

                delete(listingUrl.page)
            }
            listingUrl = encodeURL(listingUrl)

            const basCyoStore = cyoStore()

            basCyoStore.commitMutation( 'setListingPageUrl', {listingUrl, pageType, moduleSubType} )
        }

        this.commitMutation( 'setRequestPayload', payload )
        this.commitMutation( 'setRequestFilterTags', filterTags )

    },

    async requestServer( data ){
        const cyo = cyoStore()

        // ring earring or pendnant
        const moduleType = this.getModuleType()

        const moduleSubType = this.getModuleSubType()

        // setting or diamond
        const pageType = this.getSettingListPageType()


        if ( import.meta.client && moduleType === 'cyo' && pageType === 'diamond') {

            const setting   = cyo.getSetting( moduleSubType )
            if( setting ){

                this.configureDiamondPayload( {setting})
            }
        }


        // setup request payload
        
        let payload = { ...this.getRequestPayload() }
        
        // change payload as per condition
        if ( moduleType === 'cyo' && pageType === 'setting') {
            
            payload = { ...payload, Category: moduleSubType }   
        }

        // change payload as per condition
        if ( import.meta.client && moduleType === 'cyo' && pageType === 'setting') {
            
            // payload = { ...this.getRequestPayload() }

            const diamond = cyo.getDiamond( moduleSubType )
            
            if (diamond) {

                if ( diamond.shape) {

                    payload = { ...payload, Shape: diamond.shape}
                }

                if (diamond.shape_one) {

                    payload = { ...payload, Shape: diamond.shape_one}
                }
            }            
        }


        // for wedding
        if ( moduleType === 'shop') {

            payload = { ...payload, Subtype: moduleSubType}

        }

        if ( moduleType === 'preset') {

            payload = { ...payload, Category: moduleType}

        }

         // for gift card
         if ( moduleType === 'gift_card') {

            payload = { ...payload, Subtype: moduleSubType}

        }

        this.commitMutation( 'setShowMoreLoader', { flag : false } )

        const callbackFn = ( res ) => {

            this.commitMutation( 'setSettingListingResults', { ...data, response: res } )
            this.commitMutation( 'setSettingShowSkeleton', { flag : false } )
            this.commitMutation( 'setSkeletonShowMore', { flag : false } )
        }


        // console.log('current controller', this.currentController)


        if( import.meta.client ){

            if (this.currentController) {
                this.currentController.abort();
            }
        
            this.currentController = new AbortController();
        }




        try {
            // Generate the request path
            const reqPath = cyoApiListService().requestProductListApi( {moduleType, moduleSubType, pageType}, payload )

            const requestBody = import.meta.client ? { method: 'GET', signal: this.currentController.signal } : { method: 'GET'}

            // Make the GET request using Axios with the abort signal
            const useFetchPromise = await $fetch( reqPath, requestBody )

            // Pass the response data to the callback function
            await callbackFn( useFetchPromise.data  )

        } catch (error) {
            console.log('error', error)
       }
    },


    // improve this later
    toggleSettingListingShowMore(vuexContext) {

        this.commitMutation( 'toggleSettingListingShowMore' )
        this.commitMutation( 'setSkeletonShowMore', { flag : true } )
        this.requestServer()

    },


    async setDiamondCompareListItems( data ){


        let url = ( data.moduleSubType === 'earring' ) ? 'diamond/loose-pair/compare/get' : 'diamond/compare/get'
        
        try {
            const res = await $fetch(useCountryPath(url))
            if(res.data?.length){
                this.commitMutation( 'setDiamondCompareListItems', res )
            }
           
        } catch (error) {
            console.log(error,'error')
        }
       
    },

    async setShowMoreLoader(data){
        this.commitMutation( 'setShowMoreLoader', data)
    },
    async setDiamondCompareListCount( data ){


        let url = ( data.moduleSubType === 'earring' ) ?  'diamond/loose-pair/compare/get' : 'diamond/compare/get'
        
        try {
            const res = await $fetch(useCountryPath(url))
            this.commitMutation( 'setDiamondCompareListItems', res )
            if(res?.data && Array.isArray(res?.data) ){
                this.commitMutation( 'setDiamondCompareListCount', res.data.length )
            }
        } catch (error) {
            console.log(error)
        }
    },


    // improve this later
    markAddOrRemoveFromCompare(data) {

        this.commitMutation( 'markAddOrRemoveFromCompare', data )
    },

    async actionValidateUrlParam( vuexContext ){

        productListingHelpers.init( this )

        return productListingHelpers.validateUrlParam(  )

        // this.commitMutation( 'setRequestPayload', payload )
    },
}




























// // Define and export the actions function

// import cyoApiListService from '~/services/api/cyoListApi';
// import  productListingHelpers from '~/utils/helper/cyoProductListHelper.js';


// export default function useActions(state, getters, mutation){

//   async function setupCyoSettingFilter(data) {

//     mutation.setupCyoSettingFilter(state, { ...data } )

//     mutation.setSettingListingResults(state, { clearListing: true, response: { data: [], total: 0, next_page_url: null } })

//     const res = await cyoApiListService().getMinMax( data )

//     mutation.setCyoSettingFilterOptions(state, res)
    
//     // console.log('getMinMax 2', res)

    
//     // setupCyoSettingFilterFromUrl( data )
//     // await this.setRequestPayload({ unsetStartWith: false })

//   }


//   function setupCyoSettingFilterFromUrl(data) {

//     // console.log('setupCyoSettingFilterFromUrl', setupCyoSettingFilterFromUrl)
//     productListingHelpers.init( getters, data )

//     // productListingHelpers.setFiltersFromUrl()
//   }

//   return {
//     setupCyoSettingFilter,
//   };
// }
